import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import {serializeQueryParam} from "@/utils";

// eslint-disable-next-line import/prefer-default-export
export const getAllNews = createAsyncThunk('news/getAllNews',
  async ( param : GetAllNewsProps) => {
    const paramText = serializeQueryParam(param)
    const response: AxiosResponse<NewsPagination> = await instance.get(`/v1/news${paramText}`)

    const { status, ...rest } = param
    const paramText2 = serializeQueryParam({...rest})
    const summaryResponse: AxiosResponse<NewsSummary> = await instance.get(`/v1/news/summary${paramText2}`)

    const news = {
      items: response.data.items,
      meta: response.data.paging,
      summary: summaryResponse.data
    } as NewsState

    return news
})

export const createNews = createAsyncThunk('news/createNews',
  async ( request : NewsRequest,  {dispatch}) => {
    await instance.post(`/v1/news`, request)
    dispatch(getAllNews({ status: "", search: ""}))
})

export const updateNews = createAsyncThunk('news/updateNews',
  async ( request : NewsRequest,  {dispatch}) => {
    await instance.put(`/v1/news/${request.id}`, request)
    dispatch(getAllNews({status: "", search: ""}))
})

export const deleteNews = createAsyncThunk('news/deleteNews',
  async (id: string,  {dispatch}) => {
    await instance.delete(`/v1/news/${id}`)
    dispatch(getAllNews({status: "", search: ""    }))
})

export const getNewsById = createAsyncThunk('news/getNewsById',
  async ( {newsId, success } : GetNewsProps) => {
    const response: AxiosResponse<News> = await instance.get(`/v1/news/${newsId}`)
    success(response.data)
})

